module.exports = __webpack_public_path__ + "assets-cabinet/img/level-check-icon.aeafc9d9.svg";